export default "__VITE_PUBLIC_ASSET__06448a2b__"